import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { TypographyComponent } from '../typography/typography.component';
import { DialogRef } from './dialog-ref';
import { IconValuesType } from '../icon/icon.component.types';
import { ButtonComponent } from '../button';

@Component({
  selector: 'hyperkit-dialog',
  standalone: true,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  imports: [CommonModule, IconComponent, TypographyComponent, ButtonComponent], 
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReusableDialogComponent<T = unknown> {
  @Input() headerText?: string;
  @Input() headerIcon?: IconValuesType;
  @Input() primaryButtonText?: string;
  @Input() secondaryButtonText?: string;
  
  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
  
  /** Injecting dependencies without constructor boilerplate */
  public dialogRef = inject<DialogRef<T> | null>(DialogRef, { optional: true });

  onClose(): void {
    this.dialogRef?.close();
  }
  
  onPrimaryAction(): void {
    this.primaryAction.emit();
  }
  
  onSecondaryAction(): void {
    this.secondaryAction.emit();
  }
}
